module.exports = __webpack_public_path__ + "img/qr-yappy.d214281c.png";